export default {
  page: {
    title: "Kartenleser-Verwaltung",
    subtitle:
      "POS-Kartenleser registrieren, SumUp-Terminals koppeln und mit Geräten verknüpfen",
    tabReaders: "Kartenleser",
    tabPresets: "Kartenleser-Vorlagen",
    newReader: "Neuer Kartenleser",
    searchPlaceholder: "Nach Seriennummer, Marke, Modell suchen…",
    showMockReaders: "Mock-Terminals anzeigen",
    filterPairing: "Kopplung",
    filterDeviceStatus: "Gerätestatus",
    filterStatusAll: "Alle",
    filterDeviceOnline: "Online",
    filterDeviceUnavailable: "Nicht verfügbar",
    filterDeviceUnknown: "Nicht geprüft",
    colBrand: "Marke",
    colSerial: "Seriennummer",
    colRegion: "Region",
    colStatus: "Status",
    colDevice: "Zugewiesenes Gerät",
    colActions: "Aktionen",
    emptySearch: "Keine Kartenleser entsprechen Ihrer Suche.",
    emptyDefault: "Noch keine Kartenleser registriert.",
    deleteTitle: "Kartenleser löschen",
    deleteConfirm:
      'Kartenleser „{{serial}}" aus dem Bestand löschen? Dies kann nicht rückgängig gemacht werden.',
    deleteConfirmPaired:
      'Kartenleser „{{serial}}" löschen? Die SumUp-Kopplung wird aufgehoben und er aus dem Bestand entfernt. Dies kann nicht rückgängig gemacht werden.',
    readerDeleted: "Kartenleser gelöscht",
    readerRenamed: "Seriennummer des Kartenlesers aktualisiert",
    readerCreated: "Kartenleser registriert",
    readerPaired: "Kartenleser mit SumUp gekoppelt",
    readerUnpaired: "Kartenleser von SumUp entkoppelt",
    statusCreated: "Erstellt",
    statusNotPaired: "Nicht gekoppelt",
    statusPaired: "Gekoppelt",
    deviceOnline: "Online",
    deviceOffline: "Offline",
    deviceBattery: "Akku: {{level}}%",
    deviceState: {
      IDLE: "Bereit",
      SELECTING_TIP: "Trinkgeld wählen",
      UPDATING_FIRMWARE: "Firmware-Update",
      WAITING_FOR_CARD: "Wartet auf Karte",
      WAITING_FOR_PIN: "Wartet auf PIN",
      WAITING_FOR_SIGNATURE: "Wartet auf Unterschrift",
      UNKNOWN: "Unbekannter Status",
    },
    deviceLastChecked: "Letzte Prüfung: {{time}}",
    deviceLastActivity: "Letzte Aktivität: {{time}}",
    refreshAllDeviceStatuses: "Gerätestatus aktualisieren",
    deviceStatusesRefreshed: "Gerätestati aktualisiert",
    deviceStatusesRefreshedPartial:
      "{{updated}} Gerätestatus aktualisiert; {{failed}} fehlgeschlagen",
    deviceStatusesRefreshFailed:
      "{{failed}} Gerätestatus konnten nicht aktualisiert werden",
    deviceStatusesNothingToRefresh:
      "Keine gekoppelten SumUp-Kartenleser zum Aktualisieren",
    regionLocked: "Gesperrt",
    regionLockedHint:
      "Region nach erfolgreicher Zahlung gesperrt und kann nicht geändert werden",
    openAssignedDevice: "Gerät {{name}} öffnen",
    pairAction: "Mit SumUp koppeln",
    unpairAction: "Von SumUp entkoppeln",
    unlinkFromDeviceAction: "Vom Gerät trennen",
    unlinkFromDeviceConfirm:
      'Kartenleser „{{serial}}" vom Gerät „{{device}}" trennen? Die SumUp-Kopplung bleibt; Zahlungen bleiben deaktiviert, bis Sie ihn wieder verbinden.',
    readerUnlinkedFromDevice: "Kartenleser vom Gerät getrennt",
    changeRegionAction: "Region ändern",
    regionUpdated: "Kartenleser-Region aktualisiert",
    unpairConfirm:
      'Kartenleser „{{serial}}" von SumUp entkoppeln? Er bleibt im Bestand.',
  },
  renameModal: {
    title: "Kartenleser umbenennen",
    help: "Seriennummer für Kartenleser {{serial}} aktualisieren.",
    serialLabel: "Seriennummer",
    serialPlaceholder: "Geräte-Seriennummer eingeben",
    serialRequired: "Seriennummer ist erforderlich",
  },
  createModal: {
    title: "Kartenleser registrieren",
    serialLabel: "Seriennummer",
    serialPlaceholder: "Geräte-Seriennummer eingeben",
    serialRequired: "Seriennummer ist erforderlich",
    regionLabel: "Region",
    chooseRegion: "Region auswählen…",
    regionRequired: "Wählen Sie eine Region",
    presetSelectorTitle: "Kartenleser-Vorlage wählen",
    presetsEmpty:
      "Keine Vorlagen gefunden. Erstellen Sie zuerst eine im Tab Kartenleser-Vorlagen.",
    presetCardSpecs: "{{model}} • {{provider}} • {{flow}}",
    presetRequired: "Bitte wählen Sie eine Kartenleser-Vorlage",
    submit: "Kartenleser registrieren",
  },
  pairModal: {
    title: "SumUp-Kartenleser koppeln",
    help: "Geben Sie den auf Terminal {{serial}} angezeigten Kopplungscode ein.",
    codeLabel: "Kopplungscode",
    codePlaceholder: "8–9 Zeichen",
    codeInvalid:
      "Geben Sie den 8–9-stelligen Kopplungscode vom SumUp-Gerät ein.",
    submit: "Kartenleser koppeln",
  },
  changeRegionModal: {
    title: "Kartenleser-Region ändern",
    help: "Zahlungsregion für Kartenleser {{serial}} auswählen.",
    regionLabel: "Region",
    regionRequired: "Region ist erforderlich",
    unpairWarning:
      "Dieser Kartenleser ist mit SumUp gekoppelt. Eine Regionsänderung löscht ihn bei SumUp und hebt die lokale Kopplung auf.",
    unpairConfirm:
      'Region für „{{serial}}" ändern? Die SumUp-Kopplung wird automatisch entfernt.',
    submit: "Region speichern",
  },
  presets: {
    brandPlaceholder: "Marke (z. B. SumUp)",
    modelPlaceholder: "Modell (z. B. Solo)",
    providerPlaceholder: "Anbieter (z. B. SUMUP)",
    flowPlaceholder: "Ablauf (z. B. CLOUD_POS)",
    add: "Vorlage hinzufügen",
    save: "Änderungen speichern",
    updated: "Vorlage aktualisiert",
    created: "Vorlage erstellt",
    deleted: "Vorlage gelöscht",
    deleteConfirm: 'Vorlage „{{name}}" löschen?',
    deleteTitle: "Vorlage löschen",
    editTitle: "Vorlage bearbeiten",
    colBrand: "Marke",
    colModel: "Modell",
    colProvider: "Anbieter",
    colFlow: "Ablauf",
    colActions: "Aktionen",
    empty: "Noch keine Vorlagen.",
    validationRequired: "Füllen Sie alle Vorlagenfelder aus.",
  },
} as const;
